import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription, filter } from 'rxjs';
import { DataGridColumn, SummaryCard } from 'src/app/utils/interfaces';
import { UserService } from 'src/app/services/user.service';
import { UserInfo, LogStatus, LogError } from '@memberjunction/core';
import { AcsDataGridComponent } from '../shared/acs-data-grid/acs-data-grid';
import { DropdownOption } from '../shared/acs-button/acs-button';
import { DuesManagementSummaryEntity } from 'mj_generatedentities';
import { GridExportOptions, MemberChapterDuesGridColumns } from 'src/app/utils/grid-constants';
// import { DataFetchService } from 'src/app/services/data-fetch.service';
import { EntityNames } from 'src/app/utils/constants';
import { UserAuthService } from 'src/app/services/user-auth.service';
import { ActiveUserService } from 'src/app/services/active-user.service';

@Component({
  selector: 'acs-member-chapter-dues',
  templateUrl: './member-chapter-dues.html',
  styleUrls: ['../../../styles/_page-layout.scss', './member-chapter-dues-specific.scss']
})
export class MemberChapterDuesComponent implements OnInit, OnDestroy {
  @ViewChild('duesGrid') duesGrid!: AcsDataGridComponent;
  private subscription = new Subscription();
  readonly entityName = EntityNames.ChapterDuesByMembers;

  isLoading = false; // Server-side grid handles its own loading
  error: string | null = null;
  
  // Summary data
  // summary!: DuesManagementSummaryEntity;
  // summaryCards: SummaryCard[] = [];

  // Grid Configuration
  gridColumns: DataGridColumn[] = [];
  currentUser!: UserInfo;

  // Export dropdown options
  exportOptions: DropdownOption[] = GridExportOptions;

  constructor(
    private userService: UserService,
    private activeUserService: ActiveUserService,
    // private dataFetchService: DataFetchService,
    private userAuthService: UserAuthService
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.userService.getUserComplete$.pipe(filter(complete => complete)).subscribe(() => {
        this.initializeComponent();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  initializeComponent(): void {
    this.currentUser = this.activeUserService.getActiveUser()!;
    this.gridColumns = MemberChapterDuesGridColumns;
    // this.loadSummaryData();
    this.isLoading = false;
  }

  onServerDataError(error: any): void {
    LogError('Error loading member chapter dues data:', undefined, error);
    this.error = 'Failed to load member dues data. Please try again.';
  }

  onExportOptionSelected(option: DropdownOption): void {
    const format = option.value as 'csv' | 'excel' | 'pdf';
    
    // Use the duesGrid to perform the export
    if (this.duesGrid) {
      this.duesGrid.onExport(format);
      LogStatus(`Exporting all member dues records as ${format.toUpperCase()}`);
    } else {
      alert('Grid not available for export. Please try again.');
    }
  }

  // Helper methods for template
  
  get userRole(): string | null {
    // Get role from UserAuthService which fetches from API
    return this.userAuthService.getUserRole();
  }

  /*
  private async loadSummaryData(): Promise<void> {
    // Initialize summary data - will be updated when data loads
    const result = await this.dataFetchService.fetchWithParams<DuesManagementSummaryEntity>({
      EntityName: EntityNames.DuesManagementSummaries,
      OrderBy: 'MetricDate DESC',
      MaxRows: 1,
      IgnoreMaxRows: false,
      skipActiveFilter: true,
      ResultType: 'simple'
    });
    this.summary = result.data[0];

    this.updateSummaryCards();
  }

  private updateSummaryCards(): void {
    this.summaryCards = [
      {
        id: 'total-invoiced',
        value: `${this.summary.TotalInvoiced}`,
        label: 'Total Invoiced',
        icon: '🏥',
        variant: 'primary',
        format: 'currency'
      },
      {
        id: 'total-collected',
        value: `${this.summary.TotalCollected}`,
        label: 'Total Collected',
        icon: '👥',
        variant: 'success',
        format: 'currency'
      },
      {
        id: 'outstanding-amount',
        value: `${this.summary.Outstanding}`,
        label: 'Outstanding',
        sublabel: 'Amount still outstanding',
        icon: '⏳',
        variant: 'info',
        format: 'number'
      },
      {
        id: 'total-unpaid-dues',
        value: `${this.summary.MembersWithUnpaidDues}`,
        label: 'Members With Unpaid Dues',
        icon: '💰',
        variant: 'warning',
        format: 'currency'
      }
    ];
  }
  */
}